<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_9"><a id="Chapter03"></a>
Chapter 3</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c6">“Shouldn’t I stop the bleeding?”</p>
<p class="western1">“What are you going to stop it with, your
hands?”</p>
<p class="western1">“Oh, right.”</p>
<p class="western1">“Hayden?” a man asked. “Can you hear me?”</p>
<p class="western1">Carlos. I remembered his boyish face.</p>
<p class="western1">“Mmmhh,” I moaned. My vision began to focus.
A young woman leaned over me. Dark roots had grown out from
bleach-blonde, shoulder-length hair. Her skin was weathered around
the mouth and little scabs covered her chin and nose. Deep bags
hung under her eyes and her hair was thinning at her forehead. She
would be the perfect model for a Many Faces of Meth poster.</p>
<p class="western1">It felt as if my head was stuck in a vice
that was continually cracking and twisting around my skull. I tried
to push myself up; excruciating pain stung my left arm. My mind
flashed back to Dre and the interrogation. I groaned again.</p>
<p class="western1">“Need a hand?” the woman asked. I nodded and
allowed her to help me up. I leaned against the wall.</p>
<p class="western1">“Thanks,” I panted.</p>
<p class="western1">“You’re welcome,” she said. Her voice was
honey smooth, which didn’t match her worn appearance. “You look
terrible.”</p>
<p class="western1">I tried to smile and realized my lip was
swollen. “I feel terrible.”</p>
<p class="western1">She untwisted the cap off a bottle of water.
“Here,” she offered and held the bottle out to me. I took it and
sipped slowly.</p>
<p class="western1">“What are you doing in here?” I asked, not
worried about sounding ungrateful.</p>
<p class="western1">“Making sure you don’t kill yourself,” she
told me.</p>
<p class="western1">“Oh.”</p>
<p class="western1">“She’s being punished,” Carlos piped up.
“Piss off Queen Kisha you get locked up for the night.”</p>
<p class="western1">The woman wrinkled her nose and shook her
head. “That fucking bitch,” she muttered. “I swear, I’d kill her if
I could.”</p>
<p class="western1">“Don’t talk like that,” Carlos warned. “If
the wrong person hears you, you’re dead.”</p>
<p class="western1">“Everyone’s the wrong person,” she huffed.
“Except you, Spider.”</p>
<p class="western1">“I don’t go by that anymore,” he reminded
her. “And thanks.”</p>
<p class="western1">“Seriously,” the woman huffed again. “I hate
her. I don’t know why Dre is with her. He can do so much better,”
she spat bitterly.</p>
<p class="western1">I took another drink of water before I
carefully poured some over the cut on my arm. “You guys don’t like
it here?” I asked feebly.</p>
<p class="western1">“Hell no,” Carlos said at the same time the
woman said, “It’s safe.”</p>
<p class="western1">“There are other safe places,” I said
softly.</p>
<p class="western1">“You really do have a camp somewhere, don’t
you?” she asked.</p>
<p class="western1">I did my best to glare at her. “I’m not
stupid. Being nice to me isn’t going to get you answers.”</p>
<p class="western1">She held up her hands. “I’m not trying to get
answers. I hate that nasty whore just as much as you do. If there
really is somewhere safe…” she trailed off.</p>
<p class="western1">“It won’t work,” Carlos reminded her. “What
do you think happened to me last time?”</p>
<p class="western1">“What happened?” I asked.</p>
<p class="western1">“I tried to leave. I got caught. Dre beat me
an inch from my life. Said I was gonna tell people about our set up
here. Said I was gonna come back and take all the supplies.”</p>
<p class="western1">“He’s running low on supplies,” I mused.</p>
<p class="western1">“How did you know?” the woman asked, sounding
shocked.</p>
<p class="western1">“Desperation,” I answered. “Why else go
through the trouble of torturing me if he wasn’t desperate for
supplies?”</p>
<p class="western1">“She’s right,” Carlos spoke. “The guys just
take. When there’s no one left to take from, they don’t know what
to do.”</p>
<p class="western1">“Why don’t you just tell them where your camp
is?” the woman asked.</p>
<p class="western1">I shook my head. “My friends are good people.
I’d rather go through seven floors of hell than give them up.”</p>
<p class="western1">“They must be really important to you,” she
said quietly.</p>
<p class="western1">“They are my only reason for living in this
dead world,” I affirmed. The woman bit her lip and looked at the
floor. There was something about her, something desperate that made
me want to trust her, help her even. <i class="calibre4">Don’t be stupid</i>, I told
myself. “What’s your name?” I asked.</p>
<p class="western1">“Treasure,” she replied.</p>
<p class="western1">“Your real name?”</p>
<p class="western1">“Margret. Don’t call me that,” she requested
after a moment.</p>
<p class="western1">“I won’t. Why are you here, Treasure, if you
hate it?”</p>
<p class="western1">“I’ve been here,” she told me and picked at a
scab on her nose. “I was visiting my cousin,” she said quickly. Her
eyes darted to the floor and she tapped her fingernails together.
“She has hallucinations.” Her voice dropped and I almost couldn’t
hear her. “She killed her daughter. But she was possessed.”
Treasure twitched. “Or at least that’s what she thought. Then this
place went on lock down; no one could leave. I thought one of the
guys from maxi got out.”</p>
<p class="western1">“How did it get like this?” I asked and
grimaced when I moved my legs. My muscles were stiff and sore. Just
how long was I out?</p>
<p class="western1">“It took a while,” Treasure said, her voice
low. “At first it seemed like we were all on a team, ya know,
living versus the dead. It was just about making it to the next day
alive. The food started to run out…there was panic and eventually a
riot. And then Dre,” she breathed, her voice almost dreamy, “took
over. And it’s been like this ever since.”</p>
<p class="western1">“Was anyone on the inside infected?” I
inquired.</p>
<p class="western1">She nodded. “We lost, what, a hundred
people?” she asked Carlos.</p>
<p class="western1">“Give or take a few,” he replied.</p>
<p class="western1">“What happened to your cousin?” I asked
Treasure.</p>
<p class="western1">She shook her head. “She didn’t make it.”</p>
<p class="western1">“Sorry,” I said. I forced myself up right and
slowly stretched my arms forward.</p>
<p class="western1">“It’s alright,” she told me. “She was
crazy.”</p>
<p class="western1">I pushed myself up, wincing and crying out
more than once. I looked down the dimly lit hall; it was empty.
“What time is it?” I asked suddenly.</p>
<p class="western1">“Uh, prolly around four in the morning,”
Treasure answered.</p>
<p class="western1">I paced—very slowly—around the room. My legs
loosened up after a few minutes. I took a deep breath and doubled
over.</p>
<p class="western1">“What’s wrong?” Treasure asked.</p>
<p class="western1">“I think a few ribs are broken,” I answered
shortly.</p>
<p class="western1">“Shit,” she swore. “You really do look
terrible.”</p>
<p class="western1">“Thanks.” I sank down on the bed. My eyelids
were heavy and my body begged me to go to sleep. There was no way
my mind would allow me to drift off peacefully.</p>
<p class="western1">“Rest,” Treasure suggested.</p>
<p class="western1">I shook my head. “I need to come up with a
plan,” I told her.</p>
<p class="western1">“Honey, you’re locked up. Ain’t no plan gonna
get you out,” she said pointedly.</p>
<p class="western1">“You’re right. But I…I just can’t give
up.”</p>
<p class="western1">“You remind me of my sister,” she said
softly. After several minutes she spoke again, so quiet I could
barely hear her. “If there was a way out, I’d go with you.”</p>
<p class="western1">I nodded and leaned against the wall. I
closed my eyes and concentrated on taking slow breaths. I could
only inhale halfway without feeling pain. I thought about Hayden,
Ivan, Brock, and Wade. I wondered what they were doing. I felt
guilty for causing them trouble; I knew they’d be worrying and I
knew Hayden was probably freaking the fuck out.</p>
<p class="western1">“Hayden?” Treasure asked, pulling me from my
dark reverie.</p>
<p class="western1">“Yeah?”</p>
<p class="western1">“You don’t have to tell me where it is, but
do you really have a camp?”</p>
<p class="western1">“No,” I said and watched her shoulders sag.
“It’s better than a camp.”</p>
<p class="western1">She smiled, making the skin on her face
crinkle. “What’s it like?”</p>
<p class="western1">“Safe. Organized. The people are happy, well
as happy as they can be.”</p>
<p class="western1">Carlos laughed. “There’s no way a place like
that can exist. What is it, run by super heroes?”</p>
<p class="western1">“Even better; US Marines.”</p>
<p class="western1">Treasure’s eyes flicked to the dog tags. “Are
you one of them?”</p>
<p class="western1">I didn’t want to lie. For some reason, lying
about being a Marine felt wrong to me. I opened my mouth to tell
her that I was part of something else when the lights turned off. I
heard Treasure get up and move to the front of the room.</p>
<p class="western1">“Hello?” she called. “What’s going on? What’s
happening?”</p>
<p class="western1">“Generator went out,” Carlos speculated.
“It’s happened before.”</p>
<p class="western1">“No,” Treasure said, her voice trembling.
“They just filled it up. I saw the guys come back with the
gas.”</p>
<p class="western1">We sat in silence for several minutes before
the lights flickered back on.</p>
<p class="western1">“Thank God,” Treasure breathed. “I hate the
dark.”</p>
<p class="western1">“Get used to it,” Carlos told her. “The gas
will run out someday. And then we will all be fucked. The internal
locks are controlled electronically.”</p>
<p class="western1">“Not anytime—” Treasure cut off abruptly with
a scream when the lights went out again. Then they came back on.
“Ok, what the hell is going on?” she asked and moved over to me,
not wanting to be alone. “I don’t like this!” she cried.</p>
<p class="western1">The light began to get brighter. I looked out
into the hall, eyes glued to the fluorescent lights. The yellow
glow increased, the fixture humming with electricity. I turned my
head just in time. The bulbs exploded, raining glass down on the
concrete floor.</p>
<p class="western1">Muffled shouts echoed above us. Treasure’s
hand found mine as if I could protect anyone in the state I was in.
The shouts turned into screams and soon gunfire boomed in the
distance. Treasure whimpered.</p>
<p class="western1">I was listening so intently to what was going
on above us that I didn’t notice the sound of feet crunching on the
broken glass until they were in front of our room. I jumped when
the door creaked open.</p>
<p class="western1">“It’s me,” Carlos whispered. “The locks must
have shorted out. Come on, let’s get out of here.” He extended his
hand, accidentally poking me in the face. My breathing quickened
and my heart threatened to beat out of my chest. I didn’t want to
put my life in his hands, afraid he might take it away. Seeing that
I didn’t have another choice, I took his hand.</p>
<p class="western1">It was a battle just getting up the stairs. I
was winded by the time we reached ground level. Flashlights bobbed
in someone’s hand. Treasure grabbed my arm and pulled me around a
corner.</p>
<p class="western1">“Hey!” Carlos yelled. “What’s going on?”</p>
<p class="western1">“Zombies!” the guy answered and pressed a
flashlight into Carlos’ hands. “They got through the fence. They’re
surrounding us!”</p>
<p class="western1">“What do we do?”</p>
<p class="western1">“Fight ‘em off! Come on!”</p>
<p class="western1">“I gotta arm myself,” Carlos replied. “I’ll
meet ya out there.” The guy scurried past. Carlos waved to us.
Treasure kept a death grip on my hand. “If I get us out of here,”
he whispered, “will you take us to your camp?”</p>
<p class="western1">“Yes,” I promised. “If you get us out of
here.”</p>
<p class="western1">“I don’t want to go out there with those
monsters!” Treasured cried.</p>
<p class="western1">“Do you want to stay in here with these
monsters?” Carlos asked. “The raids, the beatings, the rapes; are
they any better in here?”</p>
<p class="western1">She shook her head. “Is the camp far?”</p>
<p class="western1">“Yes. We’ll need a car,” I told her.</p>
<p class="western1">“I can’t get you a car,” Carlos whispered and
took a step forward. Apprehensively, I followed.</p>
<p class="western1">“That’s fine. Just get us out of here and
I’ll find one I can hotwire.”</p>
<p class="western1">“You can hotwire cars?” he asked, stopping to
dubiously stare at me.</p>
<p class="western1">“You’re not the only one who’s been locked
up,” I admitted ruefully, though I was in jail, not a state
hospital. “Let’s go; we’re wasting time.”</p>
<p class="western1">We snaked down a hall, hid in a room to allow
more thugs to run past us, and went through a set of double
doors.</p>
<p class="western1">Adrenaline caused my pain to fade. I crouched
down and looked outside. Headlights illuminated the hospital yard.
I traced the fence with my eyes but was unable to see the break…or
any zombies.</p>
<p class="western1">“Is there another way out?” I asked.</p>
<p class="western1">“Of course,” Carlos said. “But no one is
here. Let’s go.”</p>
<p class="western1">I shook my head. “Not without knowing what
we’re up against. There could be hundreds of zombies out there. We
wouldn’t stand a chance, even if we were armed.”</p>
<p class="western1">Carlos smiled and extracted Cutter’s knife. I
shook my head and pressed a smile. “It’ll help but it’s not
enough.”</p>
<p class="western1">He nodded. “This way. There’s a window that
looks out over the east section of the yard.”</p>
<p class="western1">“Take us there.”</p>
<p class="western1">“Can’t we just leave?” Treasure
whimpered.</p>
<p class="western1">I desperately wanted to run out that door.
“No,” I said with a shake of my head. “We could get out there and
be surrounded.”</p>
<p class="western1">“Ok,” she agreed. “Let’s go—quick!”</p>
<p class="western1">The three of us scurried down the hall while
all hell broke loose outside. I remembered the time when zombies
had breached our fences at home base; I was terrified. Not only was
facing a shit ton of zombies all at once something I never wanted
to do, but facing them and fearing that they would break into the
place we called home was even worse.</p>
<p class="western1">“There,” Carlos whispered. “You can see
outside through those windows.”</p>
<p class="western1">I walked past him into a dark room and bumped
into a table, sending red and black checkers rolling across the
floor. A faint glow illuminated a large square window. I moved to
it, apprehension building in my heart. Shouts echoed off the cool
glass. Shots rang out chaotically. I squinted, trying to descry who
was alive and who was undead.</p>
<p class="western1">“There’s a herd,” I whispered, not bothering
to turn my head to look at the others. “They’re surrounding
something. I can’t tell what, though.” I shook my head and slowly
exhaled, my breath clouding the glass. “Take a guess; it can only
be one thing.” I gazed into the hazy darkness. “I don’t think
they’re going anywhere. Not until whatever—or whoever—is
eaten.”</p>
<p class="western1">“So let’s go then!” Carlos urged. “Out the
back.”</p>
<p class="western1">I nodded. “Yeah, but I don’t have a plan.
Where are we going once we get out? And <i class="calibre4">how</i> are we getting
out? Isn’t the back all fenced in?”</p>
<p class="western1">“No, it’s not,” Carlos said.</p>
<p class="western1">“It’s not?” Treasure echoed, her voice high
and tight.</p>
<p class="western1">“Not anymore. When we dug the trench, we put
in two emergency tunnels under the fence. They’re covered up with
branches and weeds. That way, if any undead followed us back, we
could get through the fence without letting them in.”</p>
<p class="western1">“That’s actually really smart,” I
blurted.</p>
<p class="western1">Carlos smiled, casting dark, eerie shadows
across his young face. “It was my idea. I used to run from my
neighbor’s dogs when I was a kid. I escaped many times by barely
squeezing through a ditch under the fence. The dogs were too big to
get through.”</p>
<p class="western1">“Ok, great. Take us to the tunnels. Once
we’re out we need somewhere to go.”</p>
<p class="western1">“Those old buildings,” Treasure
suggested.</p>
<p class="western1">“The greenhouses,” I spoke, and fear
fluttered through my heart. Hayden’s truck was hidden in one of the
old greenhouses. What if it wasn’t there anymore? “Yes, that will
work.” I looked out the window not liking my plan. It sucked, I was
aware, but it was the only one I could come up with. “Look!” I said
suddenly. “The zombies are crowded around…what is that, a
truck?”</p>
<p class="western1">I put a hand on the window and leaned
forward, narrowing my eyes. It was a truck. An old white and red
Ford. Zombies crowded around the bed, reaching and clawing.
Something had to be in it…something alive and edible. My eyes
flicked several yards behind it at the make-shift fence that the
truck had driven through.</p>
<p class="western1">I looked at the truck again. Zombies shuffled
through the hospital yard and crowded around the vehicle, blocking
out the illuminated headlights. What the hell was in the bed? Had
someone tried to reach the safety of the hospital walls? I shook my
head; it didn’t make sense to drive through the fence. It was
crappily built to say the least, but it would have at least slowed
down a herd.</p>
<p class="western1">Something flapped from the antenna of the
truck. I rested my forehead against the window but was unable to
tell exactly what it was, though it looked like some sort of
homemade flag. What the hell was going on?</p>
<p class="western1">I tore my eyes away. “Ok,” I breathed. “They
seem distracted by whoever is in that truck. I think we can sneak
out the back.”</p>
<p class="western1">Carlos made a move to dart out the door.</p>
<p class="western1">“But first we need to arm ourselves.” I
looked into Carlos’ eyes. “What can you get us?”</p>
<p class="western1">He held up the knife that I had taken from
Cutter. “I can try and get more. Stay here; I can pass through the
halls no questions asked; I was gonna get out in the morning
anyway. You two…it’ll raise a few questions.”</p>
<p class="western1">Without so much as a look back, he darted
away, flashlight bobbing as he ran.</p>
<p class="western1">“Hayden?” Treasure asked shakily. The lights
from outside illuminated the room just enough to see her dark
silhouette.</p>
<p class="western1">“Yeah?” I responded.</p>
<p class="western1">“What are they like?”</p>
<p class="western1">“They really are monsters,” I answered
automatically. “And just as bad as you’d think.”</p>
<p class="western1">“I’ve been in here since it happened,” she
whimpered. “Are they like zombies in the movies?”</p>
<p class="western1">I shook my head. “It depends on what movies
you’ve watched.” I turned back to the window. Men ran around the
truck, shooting at the zombies. Two zombies broke away from the
struggle to get a piece of whatever was in the truck and advanced
on a guy with a shotgun. He didn’t have the chance to pull the
trigger. A pit formed in my stomach. As much as I hated the guys
who ran this place, seeing anyone get eaten by zombies made me
sick.</p>
<p class="western1">I exhaled and whirled around; Treasure
jumped. I moved to the center of the room and sat on the edge of a
table. I slowly pushed my shoulders back and gently stretched. I
pulled on my hair as I waited. Suddenly, the thought of Carlos
leaving us dawned on me. I felt like an idiot for not considering
it before. And why wouldn’t he? I was injured and would only slow
him down, not to mention the fact that he didn’t know me at all.
Would I come back for him if the roles were reversed? I wasn’t sure
I would.</p>
<p class="western1">I bit my lip. This was my chance to get out.
I didn’t know where the tunnels were, but I wasn’t going to sit
idly by. I told myself that I would give Carlos one more minute and
then I was getting my ass out of here. I counted to sixty in my
head. Then I counted back to zero.</p>
<p class="western1">Two minutes.</p>
<p class="western1">I counted once more and pushed myself off the
desk. “Let’s go,” I said to Treasure.</p>
<p class="western1">“Carlos!” she stammered. “H-he’s not back
yet!”</p>
<p class="western1">“I don’t think he is coming back,” I said
bitterly. I set my jaw and took a step toward the door. That was
what I got for trusting someone who just admitted he was in a gang.
Treasure took my hand and I yanked it away. Not only was it
annoying, but it hindered my ability to fight.</p>
<p class="western1">“Treasure? Hayden?” a male voice called from
down the hall.</p>
<p class="western1">“Carlos?” Treasure squealed.</p>
<p class="western1">“Yeah. You guys leaving without me?” he asked
with a laugh.</p>
<p class="western1">“We thought you left us,” I replied flatly.
“Did you get weapons?”</p>
<p class="western1">Carlos tucked a flashlight under his arm and
grinned. “Here,” he said and handed me the knife. “You earned it.”
He handed a crowbar to Treasure and flashed a 9mm Glock. “I only
got one loaded magazine,” he said, shaking his head. “It’ll do if
we get in a tight spot; I’ll use it as backup only,” he said and
held up the broken leg of a chair. A nail stuck out at the end.</p>
<p class="western1">“Great,” I praised. “Let’s go.”</p>
<p class="western1">We hurried down the hall to get to the back
doors. I held up my hand and edged forward to check out our
surroundings once more before we burst into the night. “You have to
get them in the head,” I whispered. Treasure was shaking but
managed to nod. “If any zombies spot us, turn off the flashlight,
ok?”</p>
<p class="western1">“Ok,” Carlos said, his voice weak.</p>
<p class="western1">“Take us right to the tunnels,” I
directed.</p>
<p class="western1">“I will,” Carlos promised.</p>
<p class="western1">“Ok, on three,” I whispered. “One, two—”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">* * *</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">I opened the door. Wind blew loose strands of
hair into my face. Ignoring them, my eyes darted around. Muted dawn
light hid behind thick clouds. It was still too dark to see more
than a few yards in front of us. Dry earth under my feet, I took a
tentative step forward. I held the knife out in front of me, ready
for an attack.</p>
<p class="western1">My heart was beating a million miles an hour.
Carlos shined the flashlight around the yard.</p>
<p class="western1">“There,” he whispered.</p>
<p class="western1">I nodded and took another step. Something
scuttled to our left. I held up my hand and froze. Carlos covered
the flashlight with his hand.</p>
<p class="western1">“What is it?” Treasured cried.</p>
<p class="western1">“Shh!” I demanded.</p>
<p class="western1">She whimpered and stumbled forward.</p>
<p class="western1">“Keep going,” I said quietly. “Be ready.”</p>
<p class="western1">Carlos uncovered the flashlight and angled
the light down, casting a glow on the ground in front of us.
Treasure grabbed the back of my shirt. Hoping it would calm her
enough to keep her mouth shut, I didn’t object and pressed on.</p>
<p class="western1">I smelled him before I heard the shuffling
feet through the dry grass. Carlos spun around, lighting up the
face of an S3. He raised his gun.</p>
<p class="western1">“No!” I loudly whispered. “Don’t waste a
bullet on him.” I quickly moved forward, ripping my shirt from
Treasure’s grasp. I brought my arm up and shoved the knife into the
gummy’s open mouth. I yanked it out and shoved him back. “Keep
going,” I instructed.</p>
<p class="western1">Jogging, Carlos led the way. A few strides in
and my ribs ached. I had to ignore it if I wanted to live. A strong
gust stirred up dry dirt, blowing it into our faces. I closed my
eyes and turned my head away from the wind. I blindly walked and
tripped over a clump of weeds. Hitting the ground intensified the
pain. I let out a grunt.</p>
<p class="western1">Carlos skidded to a stop and scooped me up.
“Almost there, chica,” he assured me. Keeping his arm linked under
mine, he gently pulled me forward.</p>
<p class="western1">“I’m fine,” I said and shrugged him off. I
ran forward, not stopping until my hands closed around the
chain-link fence. Arms extended, I leaned forward, panting.</p>
<p class="western1">“Help me find it!” Carlos called as he began
searching along the fence line. Timidly, Treasure moved about a
foot away from Carlos in the opposite direction. I needed to take a
deep breath to rid myself of the winded feeling. Squeezing the
fence in anticipation for the hurt I was sure to feel, I
inhaled.</p>
<p class="western1">Something scratched at my hands. I yanked
them back, almost dropping the knife. Fresh blood glistened on the
mouth of a zombie. She turned her head, let out a harrowing yell,
and thrashed against the fence.</p>
<p class="western1">Treasure screamed and fell to the ground,
wrapping her arms around herself. Eyes wide with terror, I rushed
forward and waited for the zombie to reach for me. Skin peeled off
her arm as she forced it through the fence; I grabbed it, pulled
her forward and jammed the knife into her eye socket. When I pulled
it back, part of her rotten eyelid stuck to the blade. I wiped it
off on the fence.</p>
<p class="western1">A gun firing made me jump. I whirled around
to see Carlos aiming the gun at a fast moving S2 that had wandered
away from the truck.</p>
<p class="western1">“Find the tunnel!” I yelled to Treasure. A
hysterical sob escaped her lips. On her hands and knees, she madly
felt around for the concealed escape route. The gun fired again and
the zombie fell to the ground. Three more lumbered over in its
place.</p>
<p class="western1">Oh shit.</p>
<p class="western1">Metal clanked behind me; I turned to see
another zombie banging on the fence. I put my face close to the
chain-link, baiting him. Half of his face was missing; maggots
wriggled around in an empty eye socket. I stabbed the knife though
his cheek and into his brain. He slumped to the ground, his skull
cracking open on impact. The foul smell of rotten bodies hung in
the air.</p>
<p class="western1">Carlos fired once more. Another S2 quickly
staggered in our direction. I rushed forward, grabbed it by the
hair, and yanked its head down, colliding it with my knee and
breaking its nose. The bones pushed up into its already-mushy
brain.</p>
<p class="western1">As soon as the body hit the ground, a half
naked, fat zombie lunged at me. I leaned back and extended my foot,
catching Fatty in the chest. I quickly shifted my weight and
brought the knife into his ear. Pain drove me to the ground.</p>
<p class="western1">“Found it!” Treasure yelled. I could hear her
throwing branches to the side. “Hurry!” she called to us.</p>
<p class="western1">“Go!” I told her. “There are too many on this
side. Go!” I risked a glance behind me to see Treasure squirming
through the tunnel. “Carlos, go!” I bellowed. “I’ll distract them!”
I pushed myself up, jumped over Fatty’s body, pulling my shoulder
back. In one swift movement, I jammed the knife into the cheek of
another zombie.</p>
<p class="western1">Having missed his brain, the zombie roared
and clawed at me. I put my hands on his shoulders and pushed. Bits
of flesh were stuck in his teeth. His breath smelled like three day
old road kill soaked in sewer water. I gagged.</p>
<p class="western1">The zombie opened its mouth and chomped the
air. The knife was in my right hand. I intended to send the sharp
metal deep into his moldy brain. But the fucker was strong. And I
was weak. He pushed forward, knocking me backwards and off my feet.
The knife slipped from my fingers.</p>
<p class="western1">Treasure screamed in the background. I thrust
my left arm up, the palm of my hand hitting the zombie’s chin. I
pushed away as hard as I could. I turned my head to look for the
knife. I couldn’t see anything in the hazy dark; too much dust had
been stirred up in our scuffle. Giving up, I put my free hand on
the side of his head and snapped his neck.</p>
<p class="western1">It didn’t kill him, but it moved his mouth a
few more inches away from me. I placed my hands on the ground and
pushed, pain shot through my chest and the cut on my left arm
burned. The zombie thrashed his body around, trying to figure out
how to bite me with his head permanently turned to the side. I
dragged myself back and used the heel of my boot to shove his face
away. Hands trembling, I slapped at the ground for the knife.</p>
<p class="western1">Hands landed on my shoulders. I jerked
away.</p>
<p class="western1">“Whoa, it’s just me,” Carlos shouted over
distant gunfire. He helped me to my feet.</p>
<p class="western1">“Thanks,” I told him. He bent over and
retrieved the knife. He wiped the bloody blade on his pants and
extended it for me. I nodded another ‘thank you’ and turned.</p>
<p class="western1">“Hurry! Hurry!” Treasure screamed. She
pressed her face against the fence. Tears streamed down her cheeks.
Three zombies came out of the darkness, moving with alarming speed.
One was missing an arm; a jagged shoulder bone and wispy muscle
swung with each jarring step.</p>
<p class="western1">“I got this!” Carlos yelled and held up the
gun. “Go!”</p>
<p class="western1">He fired once, the bullet landing in the
middle of One Arm’s forehead. I sprinted to the fence and dropped
to my knees. The gun fired once more. With my elbows, I pulled
myself forward, crying out from the pain it caused.</p>
<p class="western1">Treasure bent down and pulled me up. I jumped
away from the tunnel. Nervous sweat dripped down my back. My heart
felt like it was going to explode. I was all too aware that we had
absolutely no idea what was behind us.</p>
<p class="western1">My breath came out in ragged panting. I
wrapped trembling fingers around the wooden handle of the knife. A
heavy rustling of leaves made my skin prickle with fear.</p>
<p class="western1">“Carlos!” Treasure screamed.</p>
<p class="western1">“Be quiet!” I ordered. “Unless you want to
attract them to us!”</p>
<p class="western1">We should have heard another gunshot by now,
taking out the third and final zombie. I joined Treasure at the
fence, fear and adrenaline pumping through my veins like fire. I
easily spotted the flashlight; it was tucked under Carlos’ arm
while he messed with the gun. He yelled in frustration and pulled
the trigger.</p>
<p class="western1">Nothing happened. The gun was jammed. The
flashlight fell from his grip as he pulled back the hammer.</p>
<p class="western1">“Forget it!” I yelled. “Just go!” Carlos
didn’t move. “Carlos! Run!” The gun landed on the ground with a
thud. He scooped up the flashlight, whirled around, and dove into
the tunnel. Another gust of wind blew just as I heard a branch
snap.</p>
<p class="western1">Treasure screamed. “Carlos!” she dropped to
the ground and reached under the fence for him.</p>
<p class="western1">The zombie he had been trying to shoot had
both hands around his ankle. Carlos thrashed and kicked, doing his
best to fight him off. In a mad dash, I landed too hard on the
ground, causing a red flash of pain to sting my broken ribs. Not
allowing it to stop me, I wrapped my hand around Carlos’ wrist and
pulled.</p>
<p class="western1">A yell of pain escaped his mouth. My eyes
flitted to the zombie; it had sank its teeth into Carlos’ leg.
Another zombie hurried over. It fell to its knees and took a hold
of Carlos’ other leg. The other zombie snarled at it, like a
jealous dog protecting its bone. I flattened my body to get a
better reach under the fence.</p>
<p class="western1">“Pull!” I yelled to Treasure. On a count of
three, we tugged on Carlos’ body. His shoulders got caught on the
sharp, jagged bottom of the fence. “Kick them!” I instructed
Carlos. He madly moved his leg, blood soaking his jeans.</p>
<p class="western1">Twigs snapped behind us.</p>
<p class="western1">“Come on, come on,” I muttered frantically.
The zombies pulled back, not ready to give up their meal. Carlos
screamed as another festering mouth clamped onto his leg. His nails
dug into my hand.</p>
<p class="western1">Something fell on Treasure. She hysterically
shouted and let go of Carlos’ hand. I couldn’t breathe while lying
on my stomach. Gasping for air, I rolled to my back, twisting my
arms over my head. I attempted to sit up and yank Carlos under the
fence to safety.</p>
<p class="western1">A gummy, with the skin over his rib cage
burned off, was fighting to sink its teeth into Treasure’s
jugular.</p>
<p class="western1">“Help me!” she begged. Abhorrence radiated
through me. If I let go of Carlos, I could save Treasure. Not ready
to give up yet, I kept my left hand locked around Carlos’ wrist and
twisted once more. I blindly swung my feet and kicked something; I
wasn’t sure if it was Treasure or the gummy.</p>
<p class="western1">Suddenly, my body jerked to the side, and I
was painfully moving across the dry ground. Another zombie had
joined the feast. This one had shiny blood and chunks of skin and
clumps of what looked like fur over its arms. It grabbed Carlos by
the middle and didn’t waste any time pulling him back. With a death
grip on my wrist, Carlos took me with him. If my arm went under the
fence, I’d get bitten for sure. After one more kick at the gummy, I
quickly rolled over so that I was lying on my extended arm.</p>
<p class="western1">Carlos squeezed my hand as a zombie ripped
open his belly. They dragged him another few inches away. Still
screaming, Carlos dug his fingers into my hand, causing little
beads of blood to pool under his nails. Our eyes met for a fleeting
moment.</p>
<p class="western1">I put my right hand on the fence and pushed
off, Carlos’ nails scraping and scratching long cuts as I ripped
out of his grasp. I pulled myself to my feet and was overcome with
dizziness. I stumbled forward and fell on top of the gummy, pushing
him off of Treasure.</p>
<p class="western1">It was too dark to tell if my vision blacked
out. Vomit burned in my throat and I rolled off the gummy, landing
on the ground with a thud. Scrambling back, my hands pressed into
sharp rocks. The gummy groaned; putrid liquid dripped from its open
mouth. I had dropped the knife by the fence in my failed attempt to
save Carlos. I felt around myself for anything I could use to kill
the S3. I picked up a rock; it wasn’t big enough to do any
damage.</p>
<p class="western1">My hands closed around a stick. It wasn’t
strong enough to break though its skull, even though the bone had
to be soggy and rotten. Nonetheless, I picked it up, pushed myself
to my knees, and grabbed the gummy’s head with one hand and pulled
its face up. I shoved the stick upward through its chin. The stick
popped through the soft flesh like butter. I felt it hit the roof
of his mouth with slight resistance. I pressed his head down and
jerked the stick up.</p>
<p class="western1">The gummy went limp.</p>
<p class="western1">Treasure had both hands on the fence crying
uncontrollably. I staggered over to her, putting an arm on the
metal for support. My body trembled and I felt like I was going to
pass out. Dust floated through the stream of yellow from the
flashlight, laying several feet away from us and on the other side
of the fence. It would be almost pitch black without it.</p>
<p class="western1">The sounds of slurping and chewing filled the
air. A shutter ran through my body. I closed my eyes for just a
second and tried to get some composure. And then I realized
that—other than the sounds of Carlos being eaten—the night was
quiet.</p>
<p class="western3">Shit.</p>
<p class="western1">“We have to go,” I panted. Either everyone
was dead or the guys had taken care of the zombie situation inside
the yard. And then they would be looking for us.</p>
<p class="western1">Treasure leaned against the fence, muttering
incoherently.</p>
<p class="western1">“Now!” I said. I forced myself upright and
put my hand on Treasure’s. “They’ll come for us,” I warned and
glanced nervously at the sky. It would be easy to spot us when the
sun came up.</p>
<p class="western1">Trembling, she nodded and swallowed a sob. I
retrieved the knife.</p>
<p class="western1">“Got your weapon?” I asked Treasure.</p>
<p class="western1">“I-I dropped it,” she stuttered. I shook my
head and stepped forward.</p>
<p class="western1">“I’ll get you something. We have to go,” I
repeated. I grabbed Treasure’s hand to pull her along. Her palm was
slippery with warm blood. Wait, no it wasn’t. Mine was. “Fuck,” I
cursed when I looked at my left arm. The fragile scab had been
scraped off. Worried about getting infected, I used the knife to
cut the hem off of my shirt. I wrapped it around the cut. It was a
piss-poor bandage, but it would have to suffice for now.</p>
<p class="western1">“What do you think they’ll do if they find
us?” Treasure asked me, hiccupping.</p>
<p class="western1">“How the hell should I know?” I responded.
“You’re the one who lived with them.” I shook my head. “From the
little interaction I’ve had with your lovely roommates, I’m
guessing whatever they do won’t be fun. But they’re <i class="calibre4">not</i>
gonna find us.”</p>
<p class="western1">“How can you be sure?”</p>
<p class="western1">“I’m not sure. Now be quiet,” I snapped.
“Please,” I added. Clouds rolled across the moon. I shivered,
though the air was anything but cold. We walked for maybe thirty
seconds before Treasure asked me another question.</p>
<p class="western1">“Where are we going?”</p>
<p class="western1">“I already told you,” I whispered.</p>
<p class="western1">“Where?” she repeated.</p>
<p class="western1">“I’m trying to find the bridge.”</p>
<p class="western1">“Bridge?”</p>
<p class="western1">“Yes. Bridge. Over the ditch.”</p>
<p class="western1">“Where is the ditch?”</p>
<p class="western1">I was tempted to cut another strip off of my
shirt and gag her with it. “I’m not sure,” I said quietly. “Really,
be quiet. I need to listen for zombies or…or others ok?”</p>
<p class="western1">“Mh-hm,” she agreed.</p>
<p class="western1">I pressed my bleeding arm to my chest. It
became harder to breathe with each step. I wasn’t aware that my
pace was slowing until Treasure was a good foot ahead of me. I
shook myself and painfully took a deep breath. I was tired, hungry,
and had to pee. We trudged onward.</p>
<p class="western1">Shuffling feet crashed through the dry
underbrush. I heard the telltale death groan of a zombie several
feet behind us. Treasure grabbed my hand and squealed.</p>
<p class="western1">“You’re getting this one,” I told her and
turned around.</p>
<p class="western1">“No! Please, don’t make me!”</p>
<p class="western1">I rolled my eyes. I was currently bleeding
and hunched over in pain. Some comrade she was.</p>
<p class="western1">“I can’t!”</p>
<p class="western1">“One isn’t hard. You <i class="calibre4">can</i>.”</p>
<p class="western1">She nodded. The zombie limped closer,
stretching out its arms in our direction. I extended the knife and
was able to focus on the zombie’s face. The blood drained from my
head and I felt like I was going to pass out. The knife slipped
through my fingers. I looked into his faded eyes— eyes I knew
well—and retched.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_010.vue?3b0919f9